/*
 * @Author: your name
 * @Date: 2021-06-22 13:58:39
 * @LastEditTime: 2021-06-30 10:38:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-oms-facade\src\components\components.js
 */
import EcSearch from './EcSearch/index';
import EcTreeselect from './EcTreeselect/index';
import EcPagerBar from "./EcPagerBar/src/pagerBar.vue";
import EcIcon from "./EcIcon/src/index.vue";
import EcTableColumn from "./EcTableColumn/index";
import EcformSelect from "./EcFormSelect/index";
import EcTreeTable from "./EcTreeTable/index";
import EcFormInput from "./EcFormInput/src/index";
import EcFormRadio from "./EcFormRadio/src/index";
import EcFormCheckbox from "./EcFormCheckbox/src/index";
import EcScreenFull from "./EcScreenfull/src/index";
import EcExchange from "./EcExchange/src/index";
import EcBreadcrumb from "./EcBreadcrumb/src/index";
import EcMeta from "./EcMetaLayout/src/index";

export default {
  install: (Vue) => {
    Vue.component('ec-search', EcSearch);
    Vue.component('ec-treeselect', EcTreeselect);
    // 组件名称在此EcPagerBar和ec-pager-bar等效
    Vue.component('ec-pager-bar', EcPagerBar);
    Vue.component('ec-icon', EcIcon);
    Vue.component('ec-form-input', EcFormInput);
    Vue.component('ec-form-radio', EcFormRadio);
    Vue.component('ec-form-checkbox', EcFormCheckbox);

    Vue.component('ec-table-column', EcTableColumn);
    Vue.component('ec-form-select', EcformSelect);
    Vue.component('ec-tree-table', EcTreeTable);
    Vue.component('ec-screenfull', EcScreenFull);
    Vue.component('ec-exchange', EcExchange);
    
    Vue.component('ec-breadcrumb', EcBreadcrumb);
    Vue.component('ec-meta', EcMeta);
  }
}


// WEBPACK FOOTER //
// ./src/components/components.js